import { GridColFullWidth } from '@constants/layout';
import { MotionDiv } from '@lib/motion';
import { PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import PortableText, { TextVariant } from '@ui/Text/PortableText';
import cn from '@utils/cn';
import { useEffect, useState } from 'react';

const SCREEN_WIDTH = 460;

type Props = {
  data: PricingMainType['cardsPricing'];
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
};
export const PlanCardsMobileTabs = ({ data, activeTabIndex, setActiveTabIndex }: Props) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < SCREEN_WIDTH);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleTabClick = (index: number) => {
    setActiveTabIndex(index);
  };

  const switcherColor = data?.[0]?.planSwitcherColor?.rgb;

  return (
    <div className={cn('flex flex-col items-center justify-center', GridColFullWidth)}>
      <div className="flex w-full items-center justify-center py-8">
        <div className="relative flex h-[42px] w-full max-w-md items-center justify-around gap-2 rounded-full border border-gray-200 bg-white p-1 shadow-sm">
          {data?.[0]?.planCard?.map((planCard, index) => {
            const isSelected = activeTabIndex === index;
            const totalTabs = data?.[0]?.planCard?.length;

            return (
              <div
                onClick={() => handleTabClick(index)}
                key={index}
                className={cn(
                  `flex h-full w-24 cursor-pointer items-center
                                     justify-center rounded-full uppercase`,
                )}
              >
                {isSelected && (
                  <MotionDiv
                    layoutId="selectedTab"
                    transition={{ type: 'spring', bounce: 0, duration: 0.3 }}
                    className="absolute h-[calc(100%-4px)] rounded-full"
                    style={{
                      backgroundColor: `rgba(${switcherColor?.r},${switcherColor?.g},${switcherColor?.b},${switcherColor?.a})`,
                      width: isSmallScreen
                        ? `calc(${100 / (activeTabIndex === 3 ? 2.5 : (totalTabs ?? 1))}% - 4px)`
                        : `calc(${100 / (totalTabs ?? 1)}% - 4px)`,
                    }}
                  ></MotionDiv>
                )}
                <PortableText
                  className={cn(
                    { 'z-20 text-white': isSelected },
                    'overflow-hidden text-ellipsis whitespace-nowrap text-center',
                  )}
                  content={planCard.title}
                  variant={TextVariant.TextBodySM}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
